/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mobile-only[_ngcontent-%COMP%]{margin-bottom:0;z-index:2;width:100%;background-color:rgba(0,0,0,.5);border:0;color:#fff;border-radius:0}@media (min-width:766px){.mobile-only[_ngcontent-%COMP%]{display:none}}.desktop-only[_ngcontent-%COMP%]{margin-left:2%}"];
export { styles as styles };
